import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { JDrag } from '../../JIcons';

export const DragHandle = SortableHandle(() => (
  <JDrag style={{ cursor: 'grab', color: '#999' }} />
));
